import { Box, Text } from '@factorialco/deprecated-design-system'
import { Player } from '@lottiefiles/react-lottie-player'

import i18n from 'modules/core/lib/i18n'

import animation from './animation.json'

interface Props {
  operation: 'create' | 'update' | 'invoice'
}

const SubmitOcrAnimation = ({ operation }: Props) => {
  const OcrAnimationCaptions = {
    create: {
      header: i18n.t('expenses_v2.modals.new_expense_ocr.animation_caption_1'),
      text: i18n.t('expenses_v2.modals.new_expense_ocr.animation_caption_2'),
    },
    update: {
      header: i18n.t('expenses_v2.modals.update_expense_ocr.animation_caption_1'),
      text: i18n.t('expenses_v2.modals.update_expense_ocr.animation_caption_2'),
    },
    invoice: {
      header: i18n.t(
        'software_management.software_setups.create_payment_modal.invoice_ocr.animation_caption_1'
      ),
      text: i18n.t(
        'software_management.software_setups.create_payment_modal.invoice_ocr.animation_caption_2'
      ),
    },
  }
  return (
    <>
      <Box flexDirection="column" justifyContent="center" width="full">
        <Player autoplay loop src={animation} style={{ height: '200px' }}></Player>
      </Box>
      <Box
        alignItems="center"
        justifyContent="center"
        width="full"
        paddingTop="s24"
        paddingBottom="s48"
      >
        <Text.Header2>{OcrAnimationCaptions[operation].header}</Text.Header2>
        <Box paddingTop="s12">
          <Text.Normal>{OcrAnimationCaptions[operation].text}</Text.Normal>
        </Box>
      </Box>
    </>
  )
}

export default SubmitOcrAnimation
